var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialIcon10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32.671,
    height: 33.374,
    viewBox: "0 0 32.671 33.374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2403",
    "data-name": "Rectangle 2403",
    width: 32.671,
    height: 33.374,
    fill: "#ffe800"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10467",
    "data-name": "Group 10467",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10466",
    "data-name": "Group 10466",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29540",
    "data-name": "Path 29540",
    d: "M20.975,1.589a4.232,4.232,0,0,0-6.933.464L9.22,10.087a2.209,2.209,0,0,1-1.9,1.076H2.4a2.4,2.4,0,0,0-2.4,2.4V30.978a2.4,2.4,0,0,0,2.4,2.4H24.389a4.884,4.884,0,0,0,4.713-3.6l3.4-12.44a4.891,4.891,0,0,0-4.72-6.173H20.013l1.711-5.713a4.231,4.231,0,0,0-.749-3.86M16.328,3.423a1.563,1.563,0,0,1,2.564-.166,1.544,1.544,0,0,1,.277,1.424l-1.813,6.054a2.394,2.394,0,0,0,2.294,3.09h8.127a2.228,2.228,0,0,1,2.147,2.805l-3.4,12.44a2.213,2.213,0,0,1-2.14,1.64H8.886V13.567a4.819,4.819,0,0,0,2.621-2.111ZM6.222,13.826H2.668V30.711H6.222Z",
    transform: "translate(0 0.001)",
    fill: "#ffe800",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon10);
export default __webpack_public_path__ + "static/media/social_icon10.f8ed235862db3b071123cfda5f9109bf.svg";
export { ForwardRef as ReactComponent };